import { AUTH_REDUCER_KEY } from 'store/auth/constants'

export const loggedInFromState = state => state[AUTH_REDUCER_KEY].login.loggedIn
export const loginLoadingFromState = state => state[AUTH_REDUCER_KEY].login.loading
export const consecutiveFailedLoginsFromState = state =>
  state[AUTH_REDUCER_KEY].login.consecutiveFailedLogins
export const loginErrorMessageFromState = state => state[AUTH_REDUCER_KEY].login.errorMessage
export const intendedUsernameFromState = state => state[AUTH_REDUCER_KEY].login.intendedUsername
export const authStageFromState = state => state[AUTH_REDUCER_KEY].login.authStage
